import { FormEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getFunctions, httpsCallable } from "firebase/functions";
import { Spinner } from "@/components/shared";

export default function Setup() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(true);
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [portalName, setPortalName] = useState("HelpDesk");

  useEffect(() => {
    const fn = httpsCallable<unknown, { initialized: boolean }>(getFunctions(), "getSetupState");
    fn({}).then((res) => {
      if (res.data.initialized) navigate("/login", { replace: true });
      else setChecking(false);
    }).catch(() => setChecking(false));
  }, [navigate]);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (password !== confirm) { setError("Passwords don't match"); return; }
    if (password.length < 8) { setError("Password must be at least 8 characters"); return; }

    setLoading(true); setError("");
    try {
      const fn = httpsCallable(getFunctions(), "bootstrapFirstAdmin");
      await fn({ email: email.trim(), password, displayName, portalName });
      navigate("/login", { replace: true });
    } catch (err) {
      setError((err as Error).message || "Setup failed");
    }
    setLoading(false);
  };

  if (checking) {
    return (
      <div style={{ height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Spinner size={28} />
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--bg)", padding: 20 }}>
      <div style={{ width: 460 }} className="fade-in">
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <h1 style={{ fontSize: 28, fontWeight: 700, letterSpacing: -.5, marginBottom: 6 }}>Welcome</h1>
          <p style={{ fontSize: 14, color: "var(--text2)" }}>Set up your first admin account to get started.</p>
        </div>

        <div className="card card-body" style={{ padding: 28 }}>
          <form onSubmit={handleSubmit}>
            <div className="fg">
              <label>Portal Name</label>
              <input className="fi" required value={portalName} onChange={(e) => setPortalName(e.target.value)}
                placeholder="My Helpdesk" />
              <div style={{ fontSize: 11, color: "var(--text2)", marginTop: 4 }}>
                Shown in the header and browser title. You can change this later in Settings → Branding.
              </div>
            </div>
            <div className="fg">
              <label>Your Name</label>
              <input className="fi" required value={displayName} onChange={(e) => setDisplayName(e.target.value)}
                placeholder="Jane Smith" />
            </div>
            <div className="fg">
              <label>Email</label>
              <input className="fi" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                autoComplete="username" placeholder="admin@company.com" />
            </div>
            <div className="frow">
              <div className="fg">
                <label>Password (min 8 characters)</label>
                <input className="fi" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                  autoComplete="new-password" />
              </div>
              <div className="fg">
                <label>Confirm Password</label>
                <input className="fi" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
                  autoComplete="new-password" />
              </div>
            </div>

            {error && (
              <div style={{ marginBottom: 14, padding: "10px 12px", background: "var(--red-l)", border: "1px solid rgba(255,59,48,.2)", borderRadius: "var(--rs)", fontSize: 12, color: "var(--red-t)" }}>
                {error}
              </div>
            )}

            <button type="submit" className="btn btn-primary" style={{ width: "100%", justifyContent: "center" }} disabled={loading}>
              {loading ? <Spinner size={16} color="white" /> : "Create Admin & Continue"}
            </button>
          </form>
        </div>

        <p style={{ textAlign: "center", marginTop: 16, fontSize: 12, color: "var(--text3)" }}>
          This setup form is only available before the first admin exists. After that it redirects to sign-in.
        </p>
      </div>
    </div>
  );
}
